import b from "./index430.js";
import { resolveComponent as c, createElementBlock as r, openBlock as n, withDirectives as l, createVNode as u, withCtx as h, vShow as a, createElementVNode as o, Fragment as i, renderList as p, toDisplayString as d, normalizeClass as v, createBlock as w } from "vue";
import y from "./index231.js";
const L = ["data-component"], S = { class: "grid grid-cols-4 gap-24 mb-24" }, B = { class: "mb-16 font-bold text-h4" }, $ = { class: "flex flex-col gap-16" }, k = ["href", "target", "rel"], C = { class: "flex flex-col gap-8" }, E = { class: "flex flex-col gap-16" }, M = ["href", "target", "rel"], U = { class: "inline-block overflow-hidden shrink-0 group-hover:underline" };
function D(t, F, N, T, V, z) {
  const m = c("ms-text"), _ = c("ms-headline"), g = c("cs-expander"), x = c("cs-accordion");
  return n(), r("div", {
    "data-component": t.$options.name,
    class: "p-16 pt-32 pb-32 mb-56 screen-l:p-24 screen-l:pb-24 bg-color-brand-beige-50 screen-l:mb-72 rounded-10"
  }, [
    l(u(_, {
      type: "h2",
      class: "mb-16 screen-l:mb-24"
    }, {
      default: h(() => {
        var s;
        return [
          u(m, {
            contentTag: (s = t.headline) == null ? void 0 : s.text
          }, null, 8, ["contentTag"])
        ];
      }),
      _: 1
    }, 512), [
      [a, t.headline]
    ]),
    l(o("div", S, [
      (n(!0), r(i, null, p(t.linkLists, (s) => (n(), r("div", {
        key: s.headline,
        "data-test-id": "linkList"
      }, [
        o("div", B, d(s.headline), 1),
        o("ul", $, [
          (n(!0), r(i, null, p(s.links, (e, f) => l((n(), r("li", {
            key: "desktop" + f
          }, [
            o("a", {
              class: "flex group whitespace-nowrap truncate",
              href: e.href,
              target: e.target,
              rel: e.rel
            }, [
              o("span", {
                class: v(["group-hover:underline", { "no-shrink": e.suffix, truncate: !e.suffix }])
              }, d(e.label), 3),
              l(o("span", { class: "ml-4 overflow-hidden text-color-neutral-grey-60 text-ellipsis" }, d(e.suffix), 513), [
                [a, e.suffix]
              ])
            ], 8, k)
          ], 512)), [
            [a, !(f + 1 > 5) || t.expanded]
          ])), 128))
        ])
      ]))), 128))
    ], 512), [
      [a, t.isScreenL]
    ]),
    l(u(g, {
      expanded: t.expanded,
      class: "font-bold text-text-l",
      "onUpdate:expanded": t.onModelUpdate
    }, null, 8, ["expanded", "onUpdate:expanded"]), [
      [a, t.isScreenL && t.showMoreButton]
    ]),
    l(o("div", C, [
      (n(!0), r(i, null, p(t.linkLists, (s) => (n(), w(x, {
        key: "mobile" + s.headline,
        label: s.headline,
        hasBorder: !0
      }, {
        default: h(() => [
          o("ul", E, [
            (n(!0), r(i, null, p(s.links, (e) => (n(), r("li", {
              key: e.url
            }, [
              o("a", {
                class: "flex group whitespace-nowrap",
                href: e.href,
                target: e.target,
                rel: e.rel
              }, [
                o("span", U, d(e.label), 1),
                l(o("span", { class: "inline-block ml-4 overflow-hidden text-color-neutral-grey-60 text-ellipsis" }, d(e.suffix), 513), [
                  [a, e.suffix]
                ])
              ], 8, M)
            ]))), 128))
          ])
        ]),
        _: 2
      }, 1032, ["label"]))), 128))
    ], 512), [
      [a, !t.isScreenL]
    ])
  ], 8, L);
}
const A = /* @__PURE__ */ y(b, [["render", D]]);
export {
  A as default
};
